export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = 'a9f86c6d-8f14-4d44-a7e9-2508a0e9b275';
export const MODAL_CLOSE_SEC = 2.5;
